import { AxiosError } from 'axios'
import { useFeedback } from 'context'
import { ApiResponseTypes, UserGroupServices } from 'services'
import { useInfiniteQuery } from 'react-query'
import { useSetRecoilState } from 'recoil'
import { userGroupsList } from 'atoms'

import { getNextPageParam } from 'utils/getNextParam'
import { useParamsSelector } from 'hooks'
import { UseQueryOptionsTypes } from '../queries.types'

export const useInfiniteUserGroupQuery = (
  options: UseQueryOptionsTypes | undefined = {}
) => {
  const { useParams, enabled } = options
  const setUserGroups = useSetRecoilState(userGroupsList)

  const params = useParamsSelector()

  const queryParams = useParams ? params.objParams : {}

  const { alert } = useFeedback()

  const { data, ...infiniteQuery } = useInfiniteQuery(
    ['/user-groups', queryParams],
    (paginatedParams) =>
      UserGroupServices.paginated({
        params: {
          page: paginatedParams.pageParam,
          showInactive: queryParams.showInactive,
          orderBy: queryParams.orderBy,
          orderType: queryParams.orderType
        }
      }),
    {
      keepPreviousData: true,
      getNextPageParam,
      onSuccess: (data) => {
        setUserGroups(data?.pages.flatMap((page) => page.data))
      },
      onError: (error: AxiosError<ApiResponseTypes<unknown>>) => {
        alert.showError(error.response?.data.message || error.message)
      },
      enabled
    }
  )

  return {
    data: data?.pages.flatMap((page) => page.data) || [],
    dataCount: data?.pages.flatMap((page) => page.pagination.dataCount)[0],
    ...infiniteQuery
  }
}
